<template id="map-template">
  <div class="homeview-messagecenter-data">
    <div class="header">
      <span class="header-title title2">设备预警</span>
    </div>
    <div class="searchLine">
      <el-date-picker
        v-model="queryParams.searchDay"
        @change="getList"
        type="date"
        :clearable="false"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
      <el-input
        placeholder="输入设备名称搜索"
        v-model="queryParams.entityName"
        @keyup.native="getList"
      ></el-input>
    </div>
    <div class="table-chart"> 
      <el-table
        :data="tableData"
        ref="multipleTable"
        border
        style="width: 100%"
        :row-style="{ height: '4rem'}"
        fixed
        :show-header="false"
      >
        <el-table-column
          prop="warnTypeTranslated"
          label="预警类型"
          min-width="26%"
        >
          <template slot-scope="scope">
            <el-tag type='danger' size="mini">{{scope.row.warnTypeTranslated}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="happenTime"
          label="预警时间"
          min-width="37%"
          :formatter="formatDate"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="messageIntro"
          label="预警信息"
          min-width="37%"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.pageNum"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="queryParams.pageSize"
        layout="prev, pager, next"
        background
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getMessageList } from "@/api/src/message";

export default {
  name: "HomeViewDeviceAlarm",
  componentName: "HomeViewDeviceAlarm",
  props: {},
  data() {
    return {
      tableData: [],
      total: 0,
      queryParams: {
        entityType: 'equipment',
        searchDay: null,
        entityName: '',
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      getMessageList(this.queryParams).then(res => {
        this.tableData = res.rows;
        this.total = res.total;
      });
    },
    // 格式化预警时间
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy/MM/dd hh:mm");
    },
    // 点击每页显示的条数
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 点击切换到某页
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
  },
};
</script>